import { useState, useEffect } from "react";
import axios from "axios";

export const useApiRequest = url => {
	const [data, setData] = useState(null);
	const [isLoaded, setIsLoaded] = useState(false);
	const [error, setError] = useState(null);
	useEffect(() => {
		const abortController = new AbortController();
		const fetchData = async () => {
			axios
				.get(url, { signal: abortController.signal })
				.then(response => {
					setData(response.data);
					setIsLoaded(true);
				})
				.catch(error => {
					if (!abortController.signal.aborted) {
						setError(error);
					}
				});
		};
		if (url != null) fetchData();

		return () => {
			abortController.abort();
		};
	}, [url]);

	return { data, error, isLoaded };
};